module.exports = __webpack_public_path__ + "static/img/cca-2.25cabfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/cca-2.png
// module id = 942
// module chunks = 0